<template>
    <div id="data-container">
        <div id="container-data">
            <img src="./img/device_bg.png" alt="">



            <img :src="deviceNameStatus1" alt="" style="position: absolute;top:235px;left:720px;">
            <div style="position: absolute;top:310px;left:780px;color:#fff;">
                {{deviceName1}}
            </div>
            <img :src="deviceNameStatus2" alt="" style="position: absolute;top:490px;left:720px;">
            <div style="position: absolute;top:565px;left:780px;color:#fff;">
                {{deviceName2}}
            </div>



            <div style="position: absolute;top:295px;left:120px;color:#fff;">
                {{deviceName18}}
            </div>
            <div style="position: absolute;top:355px;left:120px;color:#fff;">
                <div>{{'分水器压力'}}</div>
                <div>{{dividePressNum+dividePressNumUnit}}</div>
            </div>
            <div style="position: absolute;top:155px;left:370px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature6+temperatureUnit6}}</div>
            </div>
            <div style="position: absolute;top:195px;left:370px;color:#fff;">
                <div>{{'流量'}}</div>
                <div>{{flowNum1+flowNumUnit1}}</div>
            </div>

            <div style="position: absolute;top:585px;left:120px;color:#fff;">
                {{deviceName19}}
            </div>
            <div style="position: absolute;top:645px;left:120px;color:#fff;">
                <div>{{'集水器压力'}}</div>
                <div>{{collectPressNum+collectPressNumUnit}}</div>
            </div>
            <div style="position: absolute;top:450px;left:180px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature7+temperatureUnit7}}</div>
            </div>
            <div style="position: absolute;top:450px;left:80px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature8+temperatureUnit8}}</div>
            </div>
            <div style="position: absolute;top:405px;left:180px;color:#fff;">
                <div>{{'开度'}}</div>
                <div>{{openTemperature1+openTemperatureUnit1}}</div>
            </div>
            <div style="position: absolute;top:405px;left:80px;color:#fff;">
                <div>{{'开度'}}</div>
                <div>{{openTemperature2+openTemperatureUnit2}}</div>
            </div>

            <div style="position: absolute;top:625px;left:420px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature6+temperatureUnit6}}</div>
            </div>



            <img :src="deviceNameStatus3" alt="" style="position: absolute;top:140px;right:395px;">
            <div style="position: absolute;top:110px;right:415px;color:#fff;">
                {{deviceName3}}
            </div>
            <img :src="deviceNameStatus4" alt="" style="position: absolute;top:360px;right:395px;">
            <div style="position: absolute;top:330px;right:415px;color:#fff;">
                {{deviceName4}}
            </div>
            <img :src="deviceNameStatus5" alt="" style="position: absolute;top:580px;right:395px;">
            <div style="position: absolute;top:550px;right:415px;color:#fff;">
                {{deviceName5}}
            </div>
            <div style="position: absolute;top:530px;right:595px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature5+temperatureUnit5}}</div>
            </div>
            <div style="position: absolute;top:590px;right:595px;color:#fff;">
                <div>{{'压力'}}</div>
                <div>{{pressNum1+pressNumUnit1}}</div>
            </div>
            <div style="position: absolute;top:820px;right:595px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature7+temperatureUnit7}}</div>
            </div>
            <div style="position: absolute;top:820px;right:505px;color:#fff;">
                <div>{{'压力'}}</div>
                <div>{{pressNum2+pressNumUnit2}}</div>
            </div>
            <div style="position: absolute;top:820px;right:405px;color:#fff;">
                <div>{{'流量'}}</div>
                <div>{{flowNum2+flowNumUnit2}}</div>
            </div>



            <img :src="deviceNameStatus6" alt="" style="position: absolute;top:85px;left:505px;">
            <div style="position: absolute;top:135px;left:505px;color:#fff;">
                {{deviceName6}}
            </div>
            <div style="position: absolute;top:185px;left:505px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum1+hzNumUnit1}}</div>
            </div>
            <img :src="deviceNameStatus7" alt="" style="position: absolute;top:85px;left:680px;">
            <div style="position: absolute;top:135px;left:680px;color:#fff;">
                {{deviceName7}}
            </div>
            <div style="position: absolute;top:185px;left:680px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum2+hzNumUnit2}}</div>
            </div>
            <img :src="deviceNameStatus8" alt="" style="position: absolute;top:85px;left:860px;">
            <div style="position: absolute;top:135px;left:860px;color:#fff;">
                {{deviceName8}}
            </div>
            <div style="position: absolute;top:185px;left:860px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum3+hzNumUnit3}}</div>
            </div>
            <img :src="deviceNameStatus9" alt="" style="position: absolute;top:85px;left:1035px;">
            <div style="position: absolute;top:135px;left:1035px;color:#fff;">
                {{deviceName9}}
            </div>
            <div style="position: absolute;top:185px;left:1035px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum4+hzNumUnit4}}</div>
            </div>



            <img :src="deviceNameStatus10" alt="" style="position: absolute;top:765px;left:560px;">
            <div style="position: absolute;top:815px;left:560px;color:#fff;">
                {{deviceName10}}
            </div>
            <div style="position: absolute;top:855px;left:560px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum5+hzNumUnit5}}</div>
            </div>
            <img :src="deviceNameStatus11" alt="" style="position: absolute;top:765px;left:738px;">
            <div style="position: absolute;top:815px;left:738px;color:#fff;">
                {{deviceName11}}
            </div>
            <div style="position: absolute;top:855px;left:738px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum6+hzNumUnit6}}</div>
            </div>
            <img :src="deviceNameStatus12" alt="" style="position: absolute;top:765px;left:915px;">
            <div style="position: absolute;top:815px;left:915px;color:#fff;">
                {{deviceName12}}
            </div>
            <div style="position: absolute;top:855px;left:915px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum7+hzNumUnit7}}</div>
            </div>
            <img :src="deviceNameStatus13" alt="" style="position: absolute;top:765px;left:1090px;">
            <div style="position: absolute;top:815px;left:1090px;color:#fff;">
                {{deviceName13}}
            </div>
            <div style="position: absolute;top:855px;left:1090px;color:#fff;">
                <div>{{'频率'}}</div>
                <div>{{hzNum8+hzNumUnit8}}</div>
            </div>



            <img :src="deviceNameStatus14" alt="" style="position: absolute;top:545px;left:670px;">
            <div style="position: absolute;top:575px;left:670px;color:#fff;">
                {{deviceName14}}
            </div>
            <div style="position: absolute;top:605px;left:670px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature1+temperatureUnit1}}</div>
            </div>
            <img :src="deviceNameStatus15" alt="" style="position: absolute;top:288px;left:670px;">
            <div style="position: absolute;top:318px;left:670px;color:#fff;">
                {{deviceName15}}
            </div>
            <div style="position: absolute;top:348px;left:670px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature2+temperatureUnit2}}</div>
            </div>
            <img :src="deviceNameStatus16" alt="" style="position: absolute;top:318px;left:961px;">
            <div style="position: absolute;top:348px;left:961px;color:#fff;">
                {{deviceName16}}
            </div>
            <div style="position: absolute;top:368px;left:961px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature3+temperatureUnit3}}</div>
            </div>
            <img :src="deviceNameStatus17" alt="" style="position: absolute;top:575px;left:961px;">
            <div style="position: absolute;top:605px;left:961px;color:#fff;">
                {{deviceName17}}
            </div>
            <div style="position: absolute;top:625px;left:961px;color:#fff;">
                <div>{{'温度'}}</div>
                <div>{{temperature4+temperatureUnit4}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import deviceImg1 from "./img/device1.png";
import deviceImgAbnormal1 from "./img/device1_abnormal.png";
import deviceImgStop1 from "./img/device1_stop.png";
import deviceImg2 from "./img/device2.png";
import deviceImgAbnormal2 from "./img/device2_abnormal.png";
import deviceImgStop2 from "./img/device2_stop.png";
import deviceImg3 from "./img/device3.png";
import deviceImgAbnormal3 from "./img/device3_abnormal.png";
import deviceImgStop3 from "./img/device3_stop.png";
import deviceImg4 from "./img/device4.png";
import deviceImgAbnormal4 from "./img/device4_abnormal.png";
import deviceImgStop4 from "./img/device4_stop.png";
import deviceImg5 from "./img/switch.png";
import deviceImgAbnormal5 from "./img/switch_abnormal.png";
import deviceImgStop5 from "./img/switch_stop.png";
import {getDeviceList,getDeviceDataList} from "@/api/device-data/index";
export default {
    data(){
        return{
            deviceName1:'',
            deviceName2:'',

            deviceName3:'',
            deviceName4:'',
            deviceName5:'',
            collectPressNum:'',
            dividePressNum:'',
            deviceDataList:[],
            deviceList:[],

            timer:'',
            deviceImgList:{
                device1:[
                    './img/device1.png',
                    './img/device1_abnormal.png',
                    './img/device1_stop.png'
                    ],
                device2:[
                    './img/device2.png',
                    './img/device2_abnormal.png',
                    './img/device2_stop.png'
                    ],
                device3:[
                    './img/device3.png',
                    './img/device3_abnormal.png',
                    './img/device3_stop.png'
                    ],
                device4:[
                    './img/device4.png',
                    './img/device4_abnormal.png',
                    './img/device4_stop.png'
                    ],
                switch:[
                    './img/switch.png',
                    './img/switch_abnormal.png',
                    './img/switch_stop.png'
                    ],
            }
        }
    },
    created(){
        console.log(deviceImgStop1);
        console.log('created');
      clearInterval(this.timer);
        this.initData();
        this.timer = setInterval(() => {
        // console.log(getDeviceList());
            this.initData();
        },15000);
    },
    mounted(){
        let self = this;
        self.screenScale($('#container-data'));
        setTimeout(()=>{
            window.onresize = () => {
                console.log('66666');
                self.screenScale($('#container-data'));
            }
        })
    },
    beforeRouteLeave(to, from, next) {
      window.onresize = null;
      clearInterval(this.timer);
      next()
    },
    destroyed(){
        console.log('destroyed');
      window.onresize = null;
      clearInterval(this.timer);
    },
    methods:{
                initData(){
                    getDeviceList().then((res)=>{
                        console.log(res);
                        this.deviceList = res.data;
                        this.deviceName1 = this.deviceList[11].name;
                        this.deviceName2 = this.deviceList[12].name;
                        this.deviceNameStatus1 = this.checkStatus(this.deviceList[11].workStatus,1);
                        this.deviceNameStatus2 = this.checkStatus(this.deviceList[12].workStatus,1);

                        this.deviceName3 = this.deviceList[0].name;
                        this.deviceName4 = this.deviceList[1].name;
                        this.deviceName5 = this.deviceList[2].name;
                        this.deviceNameStatus3 = this.checkStatus(this.deviceList[0].workStatus,2);
                        this.deviceNameStatus4 = this.checkStatus(this.deviceList[1].workStatus,2);
                        this.deviceNameStatus5 = this.checkStatus(this.deviceList[2].workStatus,2);

                        this.deviceName6 = this.deviceList[3].name;
                        this.deviceName7 = this.deviceList[4].name;
                        this.deviceName8 = this.deviceList[5].name;
                        this.deviceName9 = this.deviceList[6].name;
                        this.deviceNameStatus6 = this.checkStatus(this.deviceList[3].workStatus,3);
                        this.deviceNameStatus7 = this.checkStatus(this.deviceList[4].workStatus,3);
                        this.deviceNameStatus8 = this.checkStatus(this.deviceList[5].workStatus,3);
                        this.deviceNameStatus9 = this.checkStatus(this.deviceList[6].workStatus,3);

                        this.deviceName10 = this.deviceList[13].name;
                        this.deviceName11 = this.deviceList[14].name;
                        this.deviceName12 = this.deviceList[15].name;
                        this.deviceName13 = this.deviceList[16].name;
                        this.deviceNameStatus10 = this.checkStatus(this.deviceList[13].workStatus,4);
                        this.deviceNameStatus11 = this.checkStatus(this.deviceList[14].workStatus,4);
                        this.deviceNameStatus12 = this.checkStatus(this.deviceList[15].workStatus,4);
                        this.deviceNameStatus13 = this.checkStatus(this.deviceList[16].workStatus,4);

                        
                        this.deviceName14 = this.deviceList[7].name;
                        this.deviceName15 = this.deviceList[8].name;
                        this.deviceName16 = this.deviceList[9].name;
                        this.deviceName17 = this.deviceList[10].name;
                        this.deviceNameStatus14 = this.checkStatus(this.deviceList[7].workStatus,5);
                        this.deviceNameStatus15 = this.checkStatus(this.deviceList[8].workStatus,5);
                        this.deviceNameStatus16 = this.checkStatus(this.deviceList[9].workStatus,5);
                        this.deviceNameStatus17 = this.checkStatus(this.deviceList[10].workStatus,5);

                        

                        this.deviceName18 = this.deviceList[17].name;
                        this.deviceName19 = this.deviceList[18].name;

                        getDeviceDataList().then((resp)=>{
                            console.log(resp);
                            this.deviceDataList = resp.data;



                            this.dividePressNum = this.deviceDataList[0].data
                            this.collectPressNum = this.deviceDataList[5].data

                            this.dividePressNumUnit = this.deviceDataList[0].unit
                            this.collectPressNumUnit = this.deviceDataList[5].unit

                            

                            this.pressNum1 = this.deviceDataList[25].data
                            this.pressNumUnit1 = this.deviceDataList[25].unit

                            this.pressNum2 = this.deviceDataList[26].data
                            this.pressNumUnit2 = this.deviceDataList[26].unit



                            this.temperature1 = this.deviceDataList[9].data
                            this.temperatureUnit1 = this.deviceDataList[9].unit

                            this.temperature2 = this.deviceDataList[10].data
                            this.temperatureUnit2 = this.deviceDataList[10].unit

                            this.temperature3 = this.deviceDataList[11].data
                            this.temperatureUnit3 = this.deviceDataList[11].unit

                            this.temperature4 = this.deviceDataList[12].data
                            this.temperatureUnit4 = this.deviceDataList[12].unit

                            this.temperature5 = this.deviceDataList[13].data
                            this.temperatureUnit5 = this.deviceDataList[13].unit

                            this.temperature6 = this.deviceDataList[14].data
                            this.temperatureUnit6 = this.deviceDataList[14].unit

                            this.temperature7 = this.deviceDataList[15].data
                            this.temperatureUnit7 = this.deviceDataList[15].unit

                            this.temperature8 = this.deviceDataList[16].data
                            this.temperatureUnit8 = this.deviceDataList[16].unit


                            
                            this.hzNum1 = this.deviceDataList[17].data
                            this.hzNumUnit1 = this.deviceDataList[17].unit

                            this.hzNum2 = this.deviceDataList[18].data
                            this.hzNumUnit2 = this.deviceDataList[18].unit

                            this.hzNum3 = this.deviceDataList[19].data
                            this.hzNumUnit3 = this.deviceDataList[19].unit

                            this.hzNum4 = this.deviceDataList[20].data
                            this.hzNumUnit4 = this.deviceDataList[20].unit

                            this.hzNum5 = this.deviceDataList[21].data
                            this.hzNumUnit5 = this.deviceDataList[21].unit

                            this.hzNum6 = this.deviceDataList[22].data
                            this.hzNumUnit6 = this.deviceDataList[22].unit

                            this.hzNum7 = this.deviceDataList[23].data
                            this.hzNumUnit7 = this.deviceDataList[23].unit

                            this.hzNum8 = this.deviceDataList[24].data
                            this.hzNumUnit8 = this.deviceDataList[24].unit



                            this.flowNum1 = this.deviceDataList[27].data
                            this.flowNumUnit1 = this.deviceDataList[27].unit

                            this.flowNum2 = this.deviceDataList[28].data
                            this.flowNumUnit2 = this.deviceDataList[28].unit


                            this.openTemperature1 = this.deviceDataList[1].data
                            this.openTemperatureUnit1 = this.deviceDataList[1].unit

                            this.openTemperature2 = this.deviceDataList[2].data
                            this.openTemperatureUnit2 = this.deviceDataList[2].unit
                        })
                    })
                },
                checkStatus(status,type){
                    if(parseInt(status)==1){
                        switch (type) {
                            case 1:
                                return deviceImg1;
                                break;
                            case 2:
                                return deviceImg2;
                                break;
                            case 3:
                                return deviceImg3;
                                break;
                            case 4:
                                return deviceImg4;
                                break;
                            case 5:
                                return deviceImg5;
                                break;
                            default:
                                break;
                        }
                        // return './img/device1.png';
                    }
                    if(parseInt(status)==2){
                        
                        switch (type) {
                            case 1:
                                return deviceImgAbnormal1;
                                break;
                            case 2:
                                return deviceImgAbnormal2;
                                break;
                            case 3:
                                return deviceImgAbnormal3;
                                break;
                            case 4:
                                return deviceImgAbnormal4;
                                break;
                            case 5:
                                return deviceImgAbnormal5;
                                break;
                            default:
                                break;
                        }
                        // return './img/device1_abnormal.png';
                    }
                    if(parseInt(status)==3){
                        switch (type) {
                            case 1:
                                return deviceImgStop1;
                                break;
                            case 2:
                                return deviceImgStop2;
                                break;
                            case 3:
                                return deviceImgStop3;
                                break;
                            case 4:
                                return deviceImgStop4;
                                break;
                            case 5:
                                return deviceImgStop5;
                                break;
                            default:
                                break;
                        }
                        // return './img/device1_stop.png';
                    }
                },
                screenScale(element){
                    let width = '1920';
                    let height = '1050';
                    let offsetWidth = window.innerWidth;
                    let offsetHeight = window.innerHeight;
                    let top = 0;
                    let left = 0;
                    let scaleX = offsetWidth / width;
                    let scaleY = offsetHeight / height;
                    let scale = Math.min(scaleX, scaleY);
                    top = (offsetHeight - height * scale) / 2;
                    left = (offsetWidth - width * scale) / 2;
                    //核心代码
                    const transform = `translate(${left}px, ${top}px) scale(${scale})`;
                    element.width(width);
                    element.height(height);
                    element.css({'transform': transform});
                }
    }
}
</script>

<style>
            img {
                padding: 0;
                margin: 0;
            }
            #data-container{
                padding: 0;
                margin: 0;
                overflow: hidden;
                background: #000D20;
                height: 88vh;
            }
    #container-data {
        height: 100vh;
        margin: 0 auto;
        box-sizing: border-box;
        background: #000D20;
        /* background: url(./device_bg.png) no-repeat;
        background-size: 100% 100%; */
        overflow: hidden;
        transform-origin: left top;
        transition: transform 0.2s
    }
</style>